document.addEventListener('DOMContentLoaded', function () {
  /* ------------------------------------------------------------------ */
  /* Mobile nav drawer                                                   */
  /* ------------------------------------------------------------------ */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var drawer = document.querySelector('[data-nav-drawer]');
  var drawerClose = document.querySelector('[data-drawer-close]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    menuToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    menuToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (menuToggle && drawer) {
    menuToggle.addEventListener('click', function () {
      var isOpen = drawer.classList.contains('is-open');
      isOpen ? closeDrawer() : openDrawer();
    });
  }

  if (drawerClose) {
    drawerClose.addEventListener('click', closeDrawer);
  }

  /* ------------------------------------------------------------------ */
  /* Mega-menu: hover on desktop, tap-to-expand accordion on touch       */
  /* ------------------------------------------------------------------ */
  var megaTriggers = document.querySelectorAll('[data-mega-trigger]');

  megaTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      var isTouch = window.matchMedia('(hover: none)').matches;
      if (!isTouch) return; /* desktop uses CSS hover, no JS needed */

      e.preventDefault();
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      var isExpanded = trigger.getAttribute('aria-expanded') === 'true';

      /* close any other open mega-menu panel first */
      megaTriggers.forEach(function (other) {
        if (other !== trigger) {
          other.setAttribute('aria-expanded', 'false');
          var otherPanel = document.getElementById(other.getAttribute('aria-controls'));
          if (otherPanel) otherPanel.classList.remove('is-open');
        }
      });

      trigger.setAttribute('aria-expanded', String(!isExpanded));
      if (panel) panel.classList.toggle('is-open', !isExpanded);
    });
  });

  /* ------------------------------------------------------------------ */
  /* Footer accordion (mobile only — CSS handles desktop as static)      */
  /* ------------------------------------------------------------------ */
  var footerHeadings = document.querySelectorAll('[data-footer-toggle]');

  footerHeadings.forEach(function (heading) {
    heading.addEventListener('click', function () {
      var panel = document.getElementById(heading.getAttribute('aria-controls'));
      var isExpanded = heading.getAttribute('aria-expanded') === 'true';
      heading.setAttribute('aria-expanded', String(!isExpanded));
      if (panel) panel.classList.toggle('is-open', !isExpanded);
    });
  });

  /* ------------------------------------------------------------------ */
  /* PDP accordion (description / size & material / shipping / ask)      */
  /* ------------------------------------------------------------------ */
  var accordionToggles = document.querySelectorAll('[data-accordion-toggle]');

  accordionToggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var panel = document.getElementById(toggle.getAttribute('aria-controls'));
      var isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isExpanded));
      if (panel) panel.classList.toggle('is-open', !isExpanded);
    });
  });
});
